import { gql } from '@apollo/client'

/** Shared AdvisorAgreement fields for list + builder (ADV-D3). Types not yet in FE schema codegen. */
export const ADVISOR_AGREEMENT_FRAGMENT = gql`
  fragment AdvisorAgreementFragment on ScoAdvisorAgreement {
    id
    advisorAgreementId
    founderUserId
    founderName
    founderEmail
    founderCompanyName
    createdByUserId
    initiatingPartyKey
    companyId
    advisorUserId
    advisorName
    advisorEntityName
    advisorEmail
    advisorTitle
    advisorEngagementId
    companyStageKey
    contributionTierKey
    caliberKey
    warmIntroKey
    equityPercent
    vestingMonths
    cliffMonths
    hoursPerMonth
    termMonths
    cashHourlyRateInDollars
    valuationSnapshotInDollars
    startDate
    legalTermsAsJson
    fastTrackApplied
    statusKey
    version
    parentAdvisorAgreementId
    advisorNotes
    documensoDocumentId
    documensoSigningUrl
    founderHasSigned
    advisorHasSigned
    sentAt
    signedAt
    declinedAt
    createdAt
    updatedAt
    currentUserRole
    currentUserCanEdit
    currentUserCanDelete
    companyStage {
      id
      key
      title
    }
    contributionTier {
      id
      key
      title
    }
    caliber {
      id
      key
      title
    }
    warmIntro {
      id
      key
      title
    }
    status {
      id
      key
      title
    }
    company {
      id
      companyId
      name
    }
    founderUser {
      id
      userId
      fullName
      displayName
      email
      pictureUrl
    }
    createdByUser {
      id
      userId
      fullName
      displayName
      email
    }
    advisorUser {
      id
      userId
      fullName
      displayName
      email
      pictureUrl
    }
    recommendedEquity
    signedStoredFileId
    signedFile {
      id
      storedFileId
      fullUrl
      title
      mimeType
    }
    engagement {
      id
      advisorEngagementId
      statusKey
      category {
        id
        key
        title
      }
    }
  }
`
